module.exports = __webpack_public_path__ + "static/media/lds-logo_fi.743db677.svg";